"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../../assets/js/constants");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "gridContainer__Container",
  componentId: "sc-1t9ddok-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: ", "px;\n    padding-right: ", "px;\n    width: ", "px;\n\n    @media(", ") {\n        width: ", "px;\n    }\n\n    @media(", ") {\n        width: ", "px;\n    }\n\n    @media(", ") {\n        width: 94.221%;\n        min-width: ", "px;\n    }\n\n    @media(", ") {\n        padding-left: ", "px;\n        padding-right: ", "px;\n        width: 98.594%;\n        min-width: 320px;\n    }\n"])), _constants.layoutIndent, _constants.layoutIndent, 1360 + _constants.layoutIndent * 2, (0, _constants.breakPoint)(1366), 1032 + _constants.layoutIndent * 2, (0, _constants.breakPoint)(1024), 800 + _constants.layoutIndent * 2, (0, _constants.breakPoint)(768), 592 + _constants.layoutIndent * 2, (0, _constants.breakPoint)(320), _constants.layoutIndent / 2, _constants.layoutIndent / 2);

var Component = function Component(props) {
  return /*#__PURE__*/_react["default"].createElement(Container, props);
};

var _default = Component;
exports["default"] = _default;